import {
    FindPeopleRequest,
    IndexedPageView,
    PersonaResponseShape,
    FindPeopleJsonResponse,
    getServiceAsync,
    TFactories,
} from '../../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    runOwsRequestWithMonitor,
    Person,
    createHubPersona,
    Feature,
    fullResponseOperationOption,
    getFindPeopleContext,
    uniqBy,
    OtherKnownNetworkNames,
    WellKnownFolderNames,
} from '../../../shared';

const defaultPageView: IndexedPageView = {
    BasePoint: 'Beginning',
    Offset: 0,
    MaxEntriesReturned: 50,
};

const defaultShape: PersonaResponseShape = {
    BaseShape: 'Default',
};

const getDefaultRequest = (serviceFactory: TFactories) => {
    const defaultRequest: FindPeopleRequest = {
        IndexedPageItemView: serviceFactory.indexedPageView(defaultPageView),
        PersonaShape: serviceFactory.personaResponseShape(defaultShape),
        QueryString: null,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: false,
        Context: getFindPeopleContext(),
    };
    return defaultRequest;
};

export default function getSuggestedPersonas(): Promise<Person[]> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'GetSuggestedPersonas',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.findPeopleOperation(
                    service.Factory.findPeopleJsonRequest({
                        Header: getJsonRequestHeader(),
                        Body: service.Factory.findPeopleRequest(getDefaultRequest(service.Factory)),
                    }),
                    fullResponseOperationOption
                ),
            transformResponse: (owsResponse: FindPeopleJsonResponse) =>
                uniqBy(
                    owsResponse.Body.ResultSet.filter(
                        // Only show personas that consists of 1 contact from the RecipientCache.
                        // This blocks any Rogue Recipient Cache Contact to show in Suggested, as they
                        // would be multiple linked contacts with RecipientCache as source.
                        persona =>
                            persona.PersonaTypeString === 'Person' &&
                            persona.AttributionsArray &&
                            persona.AttributionsArray.length === 1 &&
                            persona.AttributionsArray[0].DisplayName ===
                                OtherKnownNetworkNames.CommunicationHistory &&
                            persona.AttributionsArray[0].FolderName ===
                                WellKnownFolderNames.RecipientCache
                    ),
                    persona => persona.PersonaId.Id
                ).map(createHubPersona) as Person[],
        })
    );
}
